import { IDetailExpense } from "./detailExpense.types";

export class DetailExpense implements IDetailExpense {
  rowId: string;
  dateOfExpenses: Date;
  budgetCategory: number;
  description: string;
  currency: number;
  amountInOriginalCurrency: number;
  exchangeRate: number;
  amountInEUR: number;
  constructor(item: IDetailExpense) {
    this.rowId = item.rowId;
    this.dateOfExpenses = item.dateOfExpenses;
    this.budgetCategory = item.budgetCategory;
    this.description = item.description;
    this.currency = item.currency;
    this.amountInOriginalCurrency = item.amountInOriginalCurrency;
    this.exchangeRate = item.exchangeRate;
    this.amountInEUR = item.amountInEUR;
  }
}
